"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledButton = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _localization = require("@lt/localization");
var _Context = require("./Context");
var _Button = _interopRequireDefault(require("../Button"));
var _Throbber = _interopRequireDefault(require("../Throbber/Throbber"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ALL_HOTELS_STARS = 1;
var PricewatchSubscribeFormSubmit = function PricewatchSubscribeFormSubmit(props) {
  var onSubmit = props.onSubmit,
    setIsSubscribedOnPrice = props.setIsSubscribedOnPrice;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isFetching = _useState2[0],
    setFetching = _useState2[1];
  var _useContext = (0, _react.useContext)(_Context.SubscribeContext),
    state = _useContext.state,
    STATE = _useContext.STATE,
    setState = _useContext.setState,
    isSubmitable = _useContext.isSubmitable,
    email = _useContext.email,
    hotelStars = _useContext.hotelStars,
    spamConsent = _useContext.spamConsent,
    isMobile = _useContext.isMobile,
    subscriptionParams = _useContext.subscriptionParams,
    dataLayerPush = _useContext.dataLayerPush,
    setNotConfirmedUser = _useContext.setNotConfirmedUser;
  if (state === STATE.DONE || state === STATE.ERROR) return null;
  var handleSubmit = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var params, response;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(state === STATE.DEFAULT)) {
              _context.next = 4;
              break;
            }
            setState(STATE.EDIT);
            dataLayerPush({
              event: 'pricewatch_subscription_form_expanded'
            });
            return _context.abrupt("return", null);
          case 4:
            if (isSubmitable) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", null);
          case 6:
            setFetching(true);
            params = {
              email: email,
              advertising_mail_accepted: spamConsent,
              subscription: _objectSpread(_objectSpread({}, subscriptionParams), {}, {
                stars_from: hotelStars || ALL_HOTELS_STARS
              })
            };
            _context.prev = 8;
            _context.next = 11;
            return onSubmit(params);
          case 11:
            response = _context.sent;
            dataLayerPush({
              event: 'pricewatch_subscription_form_submit',
              subscription_client_id: response.client
            });
            setIsSubscribedOnPrice();
            setNotConfirmedUser(response.confirmation_required);
            setState(STATE.DONE);
            setFetching(false);
            _context.next = 25;
            break;
          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](8);
            setState(STATE.ERROR);
            setFetching(false);
            dataLayerPush({
              event: 'pricewatch_subscription_form_error'
            });
            console.error(state, _context.t0);
          case 25:
            return _context.abrupt("return", null);
          case 26:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[8, 19]]);
    }));
    return function handleSubmit() {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledButton, {
    isMobile: isMobile,
    disabled: state === STATE.EDIT && !email || isFetching,
    onClick: handleSubmit
  }, isFetching && /*#__PURE__*/_react["default"].createElement(StyledThrobber, null), !isFetching && state === STATE.DEFAULT && /*#__PURE__*/_react["default"].createElement("span", null, t('subscribe.submit.default')), !isFetching && state === STATE.EDIT && /*#__PURE__*/_react["default"].createElement("span", null, t('subscribe.submit.edit'))));
};
var StyledButton = exports.StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "PricewatchSubscribeFormSubmit__StyledButton",
  componentId: "sc-tuhc8o-0"
})(["width:100%;height:40px;display:flex;align-items:center;justify-content:center;font-size:14px;font-style:normal;font-weight:400;line-height:16px;", ";"], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile && (0, _styledComponents.css)(["height:44px;font-size:16px;line-height:20px;"]);
});
var StyledThrobber = (0, _styledComponents["default"])(_Throbber["default"]).attrs({
  size: 20,
  color: 'blue'
}).withConfig({
  displayName: "PricewatchSubscribeFormSubmit__StyledThrobber",
  componentId: "sc-tuhc8o-1"
})(["position:relative;"]);
PricewatchSubscribeFormSubmit.propTypes = {
  onSubmit: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(PricewatchSubscribeFormSubmit);